<template>
  <wz-card title="Avisos de documentos al colaborador">
    <p class="text-muted text-sm mb-2">
      El aviso nunca lleva el documento: lleva el enlace al portal. Sale por todos los canales elegidos para los que la persona
      tenga datos. WhatsApp tiene costo por conversación y necesita proveedor.
    </p>
    <div class="flex items-center gap-2">
      <select v-model="selected" class="form-control" style="max-width: 320px">
        <option v-for="o in options" :key="o.value" :value="o.value">{{ o.label }}</option>
      </select>
      <wz-button variant="primary" @click="save">Guardar</wz-button>
    </div>
  </wz-card>
</template>

<script>
import CompanyService from '@/core/services/CompanyService'
import { Alert } from '@wizepe/wizeui'

export default {
  name: 'CompanyDeliveryChannels',
  props: {
    companyId: { type: Number, required: true },
  },
  data() {
    return {
      selected: 'CORREO',
      options: [
        { value: 'CORREO', label: 'Solo correo' },
        { value: 'WHATSAPP,CORREO', label: 'WhatsApp y correo' },
      ],
    }
  },
  async created() {
    const payload = (await CompanyService.get(this.companyId)).payload
    if (payload && payload.deliveryChannels) this.selected = payload.deliveryChannels
  },
  methods: {
    async save() {
      try {
        await CompanyService.saveDeliveryChannels(this.companyId, this.selected.split(','))
        Alert.success('Canales guardados')
      } catch (e) {
        Alert.error(e.errors ? e.errors.message : 'Error al guardar los canales')
      }
    },
  },
}
</script>
